import React from 'react';
import { translate } from '../../../common/utility/DisplayPrep';

const { READ_ONLY_FEATURES } = process.env;

const actions = READ_ONLY_FEATURES === 'true' ? ['edit'] : ['edit', 'delete'];

const defaultUiConfig = {
    name: 'Predicate',
    withActions: [...actions],
    primaryKey: 'predicateId',
    pageSize: 10,
    onFormMount: (data, hookFxns) => {
        if (data?.groupFunctionDTO?.resourceId) {
            hookFxns.updateGroupFn(data.groupFunctionDTO.resourceId);
        }
        if (data?.groupFunctionOperatorDTO?.resourceId) {
            hookFxns.updateGroupFnOperator(data.groupFunctionOperatorDTO.resourceId);
        }
        if (data?.groupFunctionOperatorParamDTO?.paramId) {
            hookFxns.updateGroupFnOperatorParam(data.groupFunctionOperatorParamDTO.paramId);
        }

        return null;
    },
    properties: {
        predicateId: {
            name: 'ID',
            defaultContent: '',
            sortable: false,
            input: (v) => {
                return typeof v?.predicateId !== 'undefined' ? 'valueDisplay' : null;
            }
        },
        parentPredicateId: {
            name: 'Parent Predicate ID',
            defaultContent: '',
            sortable: false,
            input: (v) => {
                return typeof v?.parentPredicateId !== 'undefined' ? 'valueDisplay' : null;
            }
        },
        description: {
            name: 'Description',
            defaultContent: '',
            min: 0,
            max: 2048,
            rowDisplay: false,
            sortable: false,
            input: 'multiline'
        },
        predicateType: {
            name: 'Type',
            sortable: true,
            rowDisplay: true,
            nullable: false,
            input: 'select'
        },
        predicateConjunction: {
            name: 'Conjunction',
            rowDisplay: false,
            nullable: false,
            input: 'select'
        },
        activeOverridable: {
            defaultContent: false,
            rowDisplay: false,
            name: 'Allow Inactivation?',
            input: 'checkbox',
            inputProps: {
                checkboxlabel: 'Allow toggle?'
            }
        },
        uuid: {
            rowDisplay: false,
            sortable: true,
            name: 'Uuid'
        },
        lastModId: {
            rowDisplay: false,
            sortable: true,
            name: 'Last Modified ID'
        },
        lastModDatetime: {
            rowDisplay: true,
            displayPrep: 'FullDate',
            name: 'Last Updated',
            additionalProperties: {
                Cell: ({ cell: { value } }) => {
                    return translate.ReadableDateTimeColumn(value);
                }
            }
        },
        createId: {
            rowDisplay: false,
            name: 'Create ID'
        },
        createDatetime: {
            rowDisplay: false,
            name: 'Create Datetime'
        },
        groupFunctionDTO: {
            name: 'Group Function',
            rowDisplay: false,
            sortable: false,
            accessorOverride: (v) => {
                return v?.resourceId;
            },
            input: (v) => {
                return v?.predicateType === 'PredicateGroup' ? 'select' : null;
            },
            postChangeBind: (v, onChange, hookFxns) => {
                hookFxns.updateGroupFn(v);
            }
        },
        groupFunctionOperatorDTO: {
            name: 'Operator',
            rowDisplay: false,
            sortable: false,
            accessorOverride: (v) => {
                return v?.resourceId;
            },
            input: (v) => {
                return v?.predicateType === 'PredicateGroup' ? 'select' : null;
            },
            postChangeBind: (v, onChange, hookFxns) => {
                hookFxns.updateGroupFnOperator(v);
                hookFxns.updateGroupFnOperatorParam('');
            }
        },
        groupFunctionOperatorParamDTO: {
            name: 'Selection',
            rowDisplay: false,
            sortable: false,
            accessorOverride: (v) => {
                return v?.paramId;
            },
            input: (v) => {
                return v?.predicateType === 'PredicateGroup' ? 'select' : null;
            },
            postChangeBind: (v, onChange, hookFxns) => {
                hookFxns.updateGroupFnOperatorParam(v);
            }
        },
        groupFunctionDataInput: {
            name: 'Value',
            rowDisplay: false,
            sortable: false,
            input: (v) => {
                return v?.predicateType === 'PredicateGroup' ? 'text' : null;
            }
        }
    },
    newDoc: {
        activeOverridable: true,
        createDatetime: undefined,
        createId: undefined,
        criteriaId: undefined,
        description: '',
        dtoState: 'NEW',
        lastModDatetime: undefined,
        lastModId: undefined,
        parentPredicateId: undefined,
        predicateConjunction: undefined,
        predicateOrder: undefined,
        predicateParts: [],
        predicateType: undefined,
        predicates: [],
        uuid: undefined
    },
    sortBy: {
        columnId: 'name',
        desc: false
    }
};

export default defaultUiConfig;
